export default __webpack_public_path__ + "static/media/22.953cea0d.jpg";